import React, { Component } from "react";
import Storage from "../services/storage.service";
import AdvetisementIndex from "../views/advertisements/advetisement-index";

class Advertisement extends Component {
  prefix = "scr_advertisement";

  handleWindowBeforeUnload = (e) => {
    e.preventDefault();
    Storage.clear("advertisement_redirect");
    Storage.clear("advertisement_redirect_url");
    Storage.clear("advertisement_step");
    e.returnValue = true;
  };

  constructor(props) {
    super(props);
    //Cleanup sim_deactivation redirect localStorage
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
  }

  componentWillUnmount() {
    // Clear sim deactivation localStorage identifier for redirect
    Storage.clear("advertisement_redirect");
    Storage.clear("advertisement_redirect_url");
    Storage.clear("advertisement_step");
  }
  render() {
    return (
      <div className="container page protection-channel">
        <AdvetisementIndex history={this.props.history} flow={this.props.flow} />
      </div>
    );
  }
}

export default Advertisement;
